import { getAutopayFrequencyDate } from "js/utilities/getAutopayFrequencyDate";
import { getAutoPayDescriptions } from "js/formatting/getAutoPayDescriptions";
import { getPolicyQuote } from "service/policy/getPolicyQuote";
import { sendSmsMessage } from "service/notificationservice/sendSmsMessage";
import { getAllOwnersFromParties } from "js/utilities";
import { RadioGroup } from "@headlessui/react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import moment from "moment";
import {
  getBadgeClassByPolicyStatus,
  getBadgeText,
  getPolicyType,
  stringFormattingToCurrency,
  getDraftDayDisclaimer,
  getName,
  convertToTitleCase,
  getNextPaymentDate,
} from "js/formatting";

import getPaymentProfileApi from "service/paymentServices/GetPaymentProfile/index";
import EverlakeLoadingOverlay from "components/General/EverlakeLoadingOverlay";
import setUpPolicyAutoPayApi from "service/paymentServices/AddPaymentAutopay";
import GeneralPurposeDialog from "components/General/GeneralPurposeDialog";
import AddPaymentMethod from "components/ModalDialogs/AddPaymentMethod";
import useTrackManageAutoPay from "logging/hooks/useTrackManageAutoPay";
import PaymentDialog from "components/Profile/Dialogs/PaymentDialog";
import Toast from "components/General/Toast";
import Badge from "components/General/Badge";
import config from "config/config";

export default function SetupNewAutoPay({ selectedPolicy }) {
  let navigate = useNavigate();
  let trackManageAutoPay = useTrackManageAutoPay();
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const { user } = useSelector((state) => state.user);
  const { csrUser } = useSelector((s) => s.csrUser);
  const { register, handleSubmit, getValues, setValue } = useForm({
    defaultValues: {
      billingmode: selectedPolicy?.billingMode?.toLowerCase(),
    },
  });
  const [nextPayment, setNextPayment] = useState();
  const [dateOfFrequency, setDateOfFrequency] = useState();
  const [cardNumbers, setCardNumbers] = useState([]);
  const [selected, setSelected] = useState();
  const [frequency, setFrequency] = useState([]);
  const [paymentProfile, setPaymentProfile] = useState();
  const [modalState, setModalState] = useState(false);
  const [date, setDate] = useState();
  const [isContinueDisabled, setIsContinueDisabled] = useState(true);
  const [csrUserState, setCsrUserState] = useState(false);
  const [agrementState, setAgrementState] = useState(false);
  const [data, setData] = useState();
  const [ccQuotes, setCCQuotes] = useState([]);
  const [confirmation, setConfirmation] = useState();
  const [referenceNumber, setReferenceNumber] = useState();
  const [toastDetail, setToastDetail] = useState({
    type: undefined,
    title: "",
    message: "",
  });

  const owners = getAllOwnersFromParties(selectedPolicy.parties);
  const loggedUser = owners?.find(
    (x) => x.person?.taxId === user.identityNumber
  );

  const errorOccurred = (title, message) => {
    setToastDetail({
      type: "error",
      title: title,
      message: message,
    });
  };

  function getDistinctPaymentProfile(paymentProfiles) {
    let paymentProfileList = [];
    paymentProfiles.forEach((paymentProfile) => {
      if (paymentProfile?.cardStatus === "Valid") {
        if (paymentProfileList?.length === 0) {
          paymentProfileList.push(paymentProfile);
        } else {
          let exstingPaymentProfile = paymentProfileList.find(
            (c) => c.cardNumber === paymentProfile.cardNumber
          );
          if (!exstingPaymentProfile) {
            paymentProfileList.push(paymentProfile);
          }
        }
      }
    });

    return paymentProfileList;
  }

  const getExistingCreditCard = () => {
    if (selectedPolicy?.billingTypeCode === "06") {
      let selectedProfile = paymentProfile?.find(
        (profile) =>
          profile.recurringReferenceId ===
          selectedPolicy?.creditCard?.recurringReferenceId
      );
      return selectedProfile?.cardNumber;
    } else if (selectedPolicy?.billingTypeCode === "02") {
      let accountNumber = selectedPolicy?.bankInfo?.bank?.accountNumber;

      return accountNumber?.substring(accountNumber.length - 4);
    }
    return "";
  };

  useEffect(() => {
    function getPaymentProfile() {
      if (!selectedPolicy)
        return errorOccurred(
          t("AuthCustomerManageAutoPay-errorTitle"),
          t("AuthCustomerManageAutoPay-errorMessage")
        );

      setIsLoading(true);
      if (selectedPolicy) {
        // get autopay cards for login user
        getPaymentProfileApi({
          UserId: user?.userId,
        })
          .then((response) => {
            if (response?.length > 0) {
              let paymentProfiles = getDistinctPaymentProfile(response);
              setPaymentProfile(paymentProfiles);
              let cards = paymentProfiles.map((p) => p.cardNumber);
              if (cards?.length > 0) {
                setCardNumbers(cards);
                setIsContinueDisabled(false);
                let selectedProfile = paymentProfiles.find(
                  (profile) =>
                    profile.recurringReferenceId ===
                    selectedPolicy?.creditCard?.recurringReferenceId
                );
                if (selectedProfile?.cardNumber) {
                  setValue("cardNumber", selectedProfile?.cardNumber);
                  setSelected(selectedProfile?.cardNumber);
                } else {
                  setValue("cardNumber", cards[0]);
                  setSelected(cards[0]);
                }
              }
            }
            if (!selectedPolicy?.billingMode)
              setValue("billingmode", "monthly");
            setToastDetail({
              type: undefined,
              title: "",
              message: "",
            });
          })
          .catch((error) => {
            console.error(
              "Server refused to connect, please try again later.",
              error
            );
            errorOccurred(
              t("AuthCustomerManageAutoPay-errorTitle"),
              t("AuthCustomerManageAutoPay-errorMessage")
            );
          });
      }

      if (selectedPolicy?.contractID) {
        // get policy Quote for monthly, annual, semi-annual and quarterly
        getPolicyQuote(selectedPolicy?.contractID)
          .then((response) => {
            const creditCardquotes = response.filter(
              (quoteDetail) =>
                quoteDetail?.billingType?.toLowerCase() === "credit card"
            );
            if (creditCardquotes) {
              setCCQuotes(creditCardquotes);
              setFrequency([
                {
                  title: `Monthly (${
                    creditCardquotes.find(
                      (creditCardquote) =>
                        creditCardquote?.billingMode?.toLowerCase() ===
                        "monthly"
                    ).totalModalPremiumAmount
                  })`,
                  value: "monthly",
                },
                {
                  title: `Quarterly (${
                    creditCardquotes.find(
                      (creditCardquote) =>
                        creditCardquote?.billingMode?.toLowerCase() ===
                        "quarterly"
                    ).totalModalPremiumAmount
                  })`,
                  value: "quarterly",
                },
                {
                  title: `Semi-Annually (${
                    creditCardquotes.find(
                      (creditCardquote) =>
                        creditCardquote?.billingMode?.toLowerCase() ===
                        "semi-annual"
                    ).totalModalPremiumAmount
                  })`,
                  value: "semi-annual",
                },
                {
                  title: `Annually (${
                    creditCardquotes.find(
                      (creditCardquote) =>
                        creditCardquote?.billingMode?.toLowerCase() === "annual"
                    ).totalModalPremiumAmount
                  })`,
                  value: "annual",
                },
              ]);
              setIsLoading(false);
              setDateOfFrequency(moment(selectedPolicy?.paidThroughDate));
              setNextPayment(
                getNextPaymentDate(
                  selectedPolicy?.billingMode?.toLowerCase(),
                  selectedPolicy?.paidThroughDate
                )
              );
            } else {
              console.error("getPolicyQuote returns.", response);
              setIsLoading(false);
            }
          })
          .catch((error) => {
            console.error(
              "Server refused to connect, please try again later.",
              error
            );
            errorOccurred(
              t("AuthCustomerManageAutoPay-errorTitle"),
              t("AuthCustomerManageAutoPay-errorMessage")
            );
            setIsLoading(false);
          });
      }
    }
    setDate(moment(selectedPolicy?.effectiveDate).date());
    getPaymentProfile();
  }, [selectedPolicy]);

  const checkedContinueIsDisabled = (billingMode, fourDigitCardNumber) => {
    if (ccQuotes?.length === 0 || cardNumbers?.length === 0) {
      setIsContinueDisabled(true);
      return;
    }

    if (toastDetail?.type === "error") {
      setIsContinueDisabled(true);
      return;
    }

    if (!paymentProfile || !billingMode || !fourDigitCardNumber)
      setIsContinueDisabled(true);
    else setIsContinueDisabled(false);
  };

  const getBillingMode = (billingMode) => {
    switch (billingMode) {
      case "monthly":
        return "12";
      case "quarterly":
        return "04";
      case "semi-annual":
        return "02";
      case "annual":
        return "01";
    }
  };

  const saveSetupAutoPay = (data) => {
    console.log(data);
    setAgrementState(true);
    setData({
      REPLACE_POLICY_ID: selectedPolicy?.contractID,
      REPLACE_POLICY_OWNER_NAME: getName(loggedUser.person),
      REPLACE_VIEW_BALANCE_PAID: "show",
      REPLACE_POLICY_BALANCE_PAID: selectedPolicy?.modalPremiumAmountTotal,
      REPLACE_VIEW_AMOUNT: "show",
      REPLACE_POLICY_AMOUNT: stringFormattingToCurrency(
        ccQuotes.find(
          (creditCardquote) =>
            creditCardquote?.billingMode?.toLowerCase() ===
            getValues("billingmode")
        )?.totalModalPremiumAmount
      ),
      REPLACE_POLICY_DATE: dateOfFrequency,
      REPLACE_POLICY_CARD_DETAILS: selected,
      REPLACE_VIEW_FREQUENCY: "show",
      REPLACE_POLICY_FREQUENCY: data?.billingmode,
    });
  };

  const setupAutoPay = (consentNameEntered) => {
    setAgrementState(false);
    if (csrUser?.userId) {
      //csr user can not setup autopay
      setCsrUserState(true);
    } else {
      console.log("consentNameEntered", consentNameEntered);
      setIsLoading(true);
      let pProfile = paymentProfile?.find(
        (profile) => profile.cardNumber === getValues("cardNumber")
      );
      const requestPayload = {
        paymentProfileId: pProfile?.paymentProfileId,
        policyId: selectedPolicy?.contractID,
        oldPolicyId: selectedPolicy?.oldPolicy,
        billingType: "06",
        billingMode: getBillingMode(getValues("billingmode")),
        billingModeCode: getValues("billingmode"),
        draftDay: moment(dateOfFrequency).format("DD"),
        userid: user?.userId,
        policyOwnerName: getName(loggedUser.person),
        policyPremium: ccQuotes.find(
          (creditCardquote) =>
            creditCardquote?.billingMode?.toLowerCase() ===
            getValues("billingmode")
        ).totalModalPremiumAmount,
        consentNameEntered: consentNameEntered,
        cardNumber: pProfile?.cardNumber,
        payDueAmount: true,
        pastDueAmount: selectedPolicy?.modalPremiumAmountTotal,
        blockCode: selectedPolicy?.blockCode,
        isUpdateAutoPay: false,
      };
      //api call for update autopay
      setUpPolicyAutoPayApi(requestPayload)
        .then((respone) => {
          setReferenceNumber(respone?.toUpperCase());
          setConfirmation("confirmation");
          setIsLoading(false);
          setToastDetail({
            type: "success",
            title: t("AuthCustomerSetupAutopay-successTitle"),
            message: t("AuthCustomerSetupAutopay-successMessage"),
          });
          trackManageAutoPay({
            name: "Setup Autopay",
            userId: user?.userId,
            userName: user?.userName,
            oldPolicyId: selectedPolicy?.oldPolicy,
            existingFrequency: selectedPolicy?.billingMode ?? "",
            changedFrequency: getValues("billingmode") ?? "",
            existingCreditCard: getExistingCreditCard() ?? "",
            changedCreditCard: getValues("cardNumber"),
          });
          //Send SMS Message
          if (config.COMPANY_NAME !== "everlake")
            sendSmsMessage(t("SMS-body"), config.SMS_TO_PHONE_NUMBER);
        })
        .catch((error) => {
          setIsLoading(false);
          console.error(
            "Server refused to connect, please try again later.",
            error
          );
          errorOccurred(
            t("AuthCustomerEditAutoPay-errorTitle"),
            t("AuthCustomerEditAutoPay-errorMessage")
          );
        });
    }
  };

  return (
    <>
      <EverlakeLoadingOverlay isLoading={isLoading}>
        {toastDetail?.type && (
          <Toast
            title={toastDetail.title}
            message={toastDetail.message}
            type={toastDetail.type}
          />
        )}
        <div className="container mb-8">
          <h1>
            {confirmation === "confirmation"
              ? t("AuthCustomerAutoPaySummary-title")
              : t("AuthCustomerAutoPaySummary-setUpAutoPay")}
          </h1>
          <hr />
        </div>
        <div className="container mt-8">
          {getPolicyType(selectedPolicy)} Policy #{selectedPolicy?.oldPolicy}
          {getBadgeText(selectedPolicy).includes("Past due") && (
            <span className="ml-6">
              <Badge
                status={getBadgeClassByPolicyStatus(selectedPolicy)}
                statusText={getBadgeText(selectedPolicy)}
                srPrefix="Policy"
              />
            </span>
          )}
        </div>

        <div className="container ui-component-spacing mt-8">
          <div className="w-full">
            {confirmation !== "confirmation" ? (
              <form onSubmit={handleSubmit(saveSetupAutoPay)}>
                <div className="ui-card relative mb-4 md:mb-6">
                  <div className="mt-2 grid grid-cols-5 p-6 gap-2">
                    <h3>{t("CustomerSetupNewAutopay-due-today")}</h3>
                    <div className="col-span-4">
                      <h3>
                        {stringFormattingToCurrency(
                          selectedPolicy?.modalPremiumAmountTotal
                        )}
                      </h3>
                      <p className="text-xs">
                        {t("CustomerSetupNewAutopay-subtitle")}
                      </p>
                    </div>
                    <hr className="col-span-5" />
                    <h3>{t("CustomerSetupNewAutopay-frequency")}</h3>
                    <div className="col-span-4">
                      <fieldset className="flex flex-col gap-1">
                        {frequency.map((option) => (
                          <div key={option.title}>
                            <label
                              className={`inline-flex items-center text-sm ${
                                selectedPolicy?.billingMode.toLowerCase() !==
                                option.value
                                  ? "font-normal"
                                  : undefined
                              }`}
                            >
                              <input
                                type="radio"
                                className="mr-2"
                                value={option.value}
                                {...register("billingmode")}
                                onChange={(e) => {
                                  checkedContinueIsDisabled(
                                    e.target.value,
                                    getValues("cardNumber")
                                  );
                                  setNextPayment(
                                    getNextPaymentDate(
                                      e.target.value,
                                      getAutopayFrequencyDate(
                                        selectedPolicy,
                                        e.target.value
                                      )
                                    )
                                  );
                                  setDateOfFrequency(
                                    getAutopayFrequencyDate(
                                      selectedPolicy,
                                      e.target.value
                                    )
                                  );
                                }}
                              />
                              {option.title}
                            </label>
                          </div>
                        ))}
                      </fieldset>
                    </div>
                    <hr className="col-span-5" />
                    <h3>{t("CustomerSetupNewAutopay-method")}</h3>
                    <div className="ui-form-make-payment col-span-3">
                      {cardNumbers?.length > 0 && (
                        <RadioGroup
                          className="grid grid-cols-1 lg:grid-cols-3"
                          aria-label="Select autopay method"
                          value={selected}
                          {...register("cardNumber")}
                          onChange={(value) => {
                            setSelected(value);
                            setValue("cardNumber", value);
                            checkedContinueIsDisabled(
                              getValues("billingmode"),
                              value
                            );
                          }}
                        >
                          {cardNumbers.map((card) => {
                            return (
                              <RadioGroup.Option
                                key={card}
                                className={({ checked }) =>
                                  `ui-form-card cursor-pointer font-semibold ${
                                    checked ? "selected" : ""
                                  }`
                                }
                                value={card}
                              >
                                <RadioGroup.Label as="label">
                                  <span className="block text-xxs mb-2 font-normal">
                                    {
                                      getAutoPayDescriptions(
                                        selectedPolicy,
                                        card
                                      )[0]
                                    }
                                  </span>
                                  <span className="block text-base mb-5">
                                    {
                                      getAutoPayDescriptions(
                                        selectedPolicy,
                                        card
                                      )[1]
                                    }{" "}
                                    Ending in {card}
                                  </span>
                                </RadioGroup.Label>
                                <div className="ui-form-card-checkbox">
                                  <svg
                                    className="ui-icon w-2 h-2 text-white hidden"
                                    focusable="false"
                                    aria-hidden="true"
                                    role="presentation"
                                  >
                                    <use href="#ui-icon-checkmark"></use>
                                  </svg>
                                </div>
                              </RadioGroup.Option>
                            );
                          })}
                        </RadioGroup>
                      )}
                    </div>
                    <div className="text-sm md:justify-self-end pt-2">
                      <button
                        type="button"
                        className="ui-btn-hyperlink"
                        aria-label="Edit manage auto pay"
                        onClick={() => setModalState(true)}
                      >
                        {t("CustomerSetupNewAutopay-add-method")}
                      </button>
                    </div>

                    <hr className="col-span-5" />

                    <h3>{t("CustomerSetupNewAutopay-date")}</h3>
                    <div className="col-span-4">
                      <p className="font-bold">{nextPayment}</p>
                      {!nextPayment?.includes("day of every month") && (
                        <p className="text-xs">
                          {t("CustomerSetupNewAutopay-next-payment-date")}
                        </p>
                      )}
                      <p className="text-xs">
                        {getDraftDayDisclaimer(
                          moment(dateOfFrequency).format("DD")
                        )}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="text-right">
                  <button
                    type="button"
                    className="ui-btn-secondary"
                    aria-label="Back to manage auto pay"
                    onClick={() => navigate("/payment")}
                  >
                    {t("CustomerSetupNewAutopay-back")}
                  </button>
                  <button
                    className="ui-btn-primary"
                    aria-label="Continue auto pay"
                    disabled={isContinueDisabled}
                  >
                    {t("CustomerSetupNewAutopay-continue")}
                  </button>
                </div>
              </form>
            ) : (
              <>
                <div className="ui-card relative mb-4 md:mb-6">
                  <div className="mt-2 grid grid-cols-[1fr,2fr,1fr] gap-2 px-6 py-6">
                    <h3>
                      {t(
                        "CustomerSetupNewAutopay-confirmation-balance-paid-today"
                      )}
                    </h3>
                    <div className="col-span-4">
                      <p className="font-bold">
                        {stringFormattingToCurrency(
                          selectedPolicy?.modalPremiumAmountTotal
                        )}
                      </p>
                    </div>
                    <hr className="col-span-5" />
                    <h3>{t("CustomerSetupNewAutopay-frequency")}</h3>
                    <div className="col-span-4">
                      <p className="font-bold">
                        {convertToTitleCase(getValues("billingmode"))} (
                        {stringFormattingToCurrency(
                          ccQuotes.find(
                            (ccQuote) =>
                              ccQuote.billingMode?.toLowerCase() ===
                              getValues("billingmode")
                          )?.totalModalPremiumAmount
                        )}
                        )
                      </p>
                    </div>
                    <hr className="col-span-5" />
                    {getValues("cardNumber") && (
                      <>
                        <h3>{t("CustomerSetupNewAutopay-method")}</h3>
                        <div className="ui-form-make-payment col-span-3">
                          <p className="font-bold">
                            Credit card Ending in {getValues("cardNumber")}
                          </p>
                          <span className="block text-xxs mb-2 font-normal">
                            Credit card
                          </span>
                        </div>
                        <hr className="col-span-5" />
                      </>
                    )}
                    <h3>{t("CustomerSetupNewAutopay-date")}</h3>
                    <div className="col-spoan-4">
                      <p className="font-bold">{nextPayment}</p>
                      {!nextPayment?.includes("day of every month") && (
                        <p className="text-xs">
                          {t("CustomerSetupNewAutopay-next-payment-date")}
                        </p>
                      )}
                      <p className="text-xs">
                        {getDraftDayDisclaimer(
                          moment(dateOfFrequency).format("DD")
                        )}
                      </p>
                    </div>
                    <hr className="col-span-5" />
                    <div className="col-span-5">
                      <h3>
                        {`Autopay was initiated on ${moment().format(
                          "MM/DD/YYYY"
                        )}. The transaction
                        reference number is: ${referenceNumber}`}
                      </h3>
                    </div>
                  </div>
                </div>
                <div className="text-right">
                  <div className="mt-1 md:mt-2 pb-4">
                    <button
                      className="ui-btn-hyperlink"
                      aria-label="Close manage auto pay"
                      onClick={() => navigate("/payment")}
                    >
                      {t("CustomerSetupNewAutopay-confirmation-back")}
                    </button>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </EverlakeLoadingOverlay>
      <AddPaymentMethod
        modalState={modalState}
        setModalState={setModalState}
        selectedPolicy={selectedPolicy}
        setToastDetail={setToastDetail}
        portalReturnURL={`/payment/manageautopay/${selectedPolicy.contractID}`}
      />
      <GeneralPurposeDialog
        title={t("CSRErrorMessage-title")}
        desc={t("CSRErrorMessage-message")}
        state={csrUserState}
        setState={setCsrUserState}
        showCloseButton={false}
      />
      <PaymentDialog
        showPaymentDialog={agrementState}
        setShowPaymentDialog={setAgrementState}
        data={data}
        action={(inputValue) => setupAutoPay(inputValue)}
      />
    </>
  );
}
